import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "@/assets/style/base.less";
import { showLoading, hideLoading } from "@/utils/loading";

//注册ElementUI
Vue.use(ElementUI);

Vue.config.productionTip = false;
window['$showLoading'] = showLoading; //????
window['$hideLoading']= hideLoading; //????

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
